import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { RenderDropdownSelect, RenderSelectField } from '../../../../../common/form';
import * as Validations from '../../../../../common/form/commonValidations'; // eslint-disable-line


function MealOptionInput({ index, mealOptions, selector, eventInvitationIndex }) {
  const rsvpField = `guests[${index}].event_invitations[${eventInvitationIndex}].rsvp_type`;
  const rsvpType = selector(rsvpField);
  const isAttending = rsvpType === 'ATTENDING';

  return (
    <div className="meal-options-container">
      {isAttending && (
        <div className="meal-options">
          <div className="hidden-xs">
            <Field
              id={`guest-form-guest-${index}-meal-option`}
              name={`guests[${index}].event_invitations[${eventInvitationIndex}].meal_option_id`}
              component={RenderDropdownSelect}
              options={mealOptions}
              placeholder="Select Meal Option"
              hideFormGroup
              validate={(value) => {
                if (!value) {
                  return 'Required';
                }
                return undefined;
              }}
              hideEmpty
            />
          </div>
          <div className="visible-xs">
            <Field
              id={`guest-form-guest-${index}-meal-option`}
              name={`guests[${index}].event_invitations[${eventInvitationIndex}].meal_option_id`}
              component={RenderSelectField}
              options={mealOptions}
              placeholder="Select Meal Option"
              hideFormGroup
              className="scroll-select"
              validate={(value) => {
                if (!value) {
                  return 'Required';
                }
                return undefined;
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
}

MealOptionInput.propTypes = {
  index: PropTypes.number,
  mealOptions: PropTypes.arrayOf(PropTypes.shape({})),
  selector: PropTypes.func,
  eventInvitationIndex: PropTypes.number
};

export default MealOptionInput;



/** WEBPACK FOOTER **
 ** ./src/components/PublicWebsite/pages/rsvpV2/RsvpForm/GuestFields/MealOptionInput.jsx
 **/